import { ReactNode, useEffect, useRef } from "react";
import {
  Menu as AriaMenu,
  Button,
  MenuItem,
  MenuTrigger,
  Popover,
} from "react-aria-components";

type MenuProps = {
  trigger: ReactNode;
  items: { id: string; element: ReactNode; action?: () => void }[];
};

export default function Menu({ trigger, items }: MenuProps) {
  return (
    <MenuTrigger>
      <Button aria-label="Menu">{trigger}</Button>
      <Popover
        ref={(ref) => ref?.addEventListener("touchend", (e) => e.preventDefault())}
      >
        <div className="pointer-events-none fixed inset-0 bg-black/60" />
        <AriaMenu className="fixed inset-x-0 bottom-0 mx-auto flex max-w-md animate-slideUp flex-col space-y-6 rounded-t-lg bg-white  p-4 text-black outline-none">
          {items?.map(({ id, action, element }) => (
            <MenuItem key={id} onAction={action}>
              {element}
            </MenuItem>
          ))}
        </AriaMenu>
      </Popover>
    </MenuTrigger>
  );
}
